import { TeamMember } from '@bw/apis/contentful';
import { logger, nonNull } from '@bw/core';
import { AgencyDetails } from '@bw/external-apis/shared';

export const startsWithThe = (marketingName: string) =>
	/^\s*The\s/.test(marketingName);

export const withoutThe = (marketingName: string) =>
	marketingName.replace(/^\s*The\s/, '');

type LegacyEmployee = AgencyDetails['employees'][number];

export function getTeamMembers(
	legacyTeamMembers: AgencyDetails['employees'],
	contentfulTeamMembers: TeamMember[],
	sortMethod: 'Legacy' | 'Contentful' // = 'Legacy'
) {
	// if sortMethod = contentful, reorder legacyTeamMembers to match contentfulTeamMembers order
	if (sortMethod === 'Contentful') {
		legacyTeamMembers = nonNull(
			contentfulTeamMembers.map((contentfulTeamMember) =>
				legacyTeamMembers.find((legacy) =>
					teamMembersAreEqual(legacy, contentfulTeamMember)
				)
			)
		).filter(Boolean);
	}

	return legacyTeamMembers.map((employee) => {
		const contentfulEmployee = contentfulTeamMembers.find((emp) =>
			teamMembersAreEqual(employee, emp)
		);
		if (!contentfulEmployee) {
			logger.error(
				`Contentful employee not found for employee ${JSON.stringify(employee)}, contentfulEmployees: ${JSON.stringify(contentfulTeamMembers)}`
			);
		}

		return {
			name: `${employee.firstName} ${employee.lastName}`,
			firstName: contentfulEmployee?.fields?.firstName ?? employee.firstName,
			lastName: contentfulEmployee?.fields?.lastName ?? employee.lastName,
			title: employee.title,
			email: employee.email,
			description: employee.description,
			photoUrl:
				contentfulEmployee?.fields.headshot ?? employee.photoFileName ?? '',
			isFeatured: employee.isFeatured ?? false,
		};
	});
}

const looselyEqual = (str1: string | undefined, str2: string | undefined) => {
	return str1?.trim()?.toLowerCase() === str2?.trim()?.toLowerCase();
};

export type AgencyTeamMember = ReturnType<typeof getTeamMembers>[number];

export const teamMembersAreEqual = (
	legacyEmployee: LegacyEmployee,
	contentfulEmployee: TeamMember
) =>
	legacyEmployee.id === contentfulEmployee.fields.legacyId ||
	(looselyEqual(
		legacyEmployee.firstName,
		contentfulEmployee.fields.firstName
	) &&
		looselyEqual(legacyEmployee.lastName, contentfulEmployee.fields.lastName));
